/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAttachmentWithSizeDto
 */
export interface GetAttachmentWithSizeDto {
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentWithSizeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentWithSizeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentWithSizeDto
     */
    objectId: string;
    /**
     * 
     * @type {number}
     * @memberof GetAttachmentWithSizeDto
     */
    fileSize?: number;
}

/**
 * Check if a given object implements the GetAttachmentWithSizeDto interface.
 */
export function instanceOfGetAttachmentWithSizeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "objectId" in value;

    return isInstance;
}

export function GetAttachmentWithSizeDtoFromJSON(json: any): GetAttachmentWithSizeDto {
    return GetAttachmentWithSizeDtoFromJSONTyped(json, false);
}

export function GetAttachmentWithSizeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttachmentWithSizeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'objectId': json['objectId'],
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
    };
}

export function GetAttachmentWithSizeDtoToJSON(value?: GetAttachmentWithSizeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'objectId': value.objectId,
        'fileSize': value.fileSize,
    };
}

